module.exports = __webpack_public_path__ + "static/media/UnknownFlag.117d55a5.svg";